export const authRouteConst = {
    login: 'login'    
};